import {
  Component,
  inject,
  ChangeDetectionStrategy
} from '@angular/core';
import { AppService } from './app.service';
import { environment } from '../environments/environment';
import { userLocale } from './models/locale.model';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AppComponent {
  private appService = inject(AppService);

  public hasValidUrlParameters$ =
    this.appService.hasValidUrlParameters$;

  public isUnsubscribed$ = this.appService.isUnsubscribed$;
  public listUnsubscribed$ = this.appService.listUnsubscribed$;
  public env = environment;

  constructor(private translateService: TranslocoService) {
    this.translateService.setActiveLang(userLocale);
    this.applyDirection(userLocale);
  }

  private applyDirection(locale: string): void {
    const rtlLocales = ['ar', 'he', 'fa'];
    const isRTL = rtlLocales.some(code => locale.startsWith(code));

    document.documentElement.setAttribute(
      'dir',
      isRTL ? 'rtl' : 'ltr'
    );
  }
}